import React, { useState, useEffect } from 'react'

import {
  Container,
  Form,
  Button,
  Offcanvas,
  Navbar,
  ListGroup,
} from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'

const GroupSideBar = ({
  companyName,
  currentCompanyId,
  setCurrentCompanyId,
}) => {
  const [searchedCompanyName, setSearchedCompanyName] = useState(companyName)
  //   const [allCompany, setAllCompany] = useState(true)
  const [inputCompanyName, setInputCompanyName] = useState('')
  //   const [closeBtn, setCloseBtn] = useState('none')
  // console.log('searchedCompanyName', searchedCompanyName)
  useEffect(() => {
    setSearchedCompanyName(companyName)
  }, [companyName])

  const handleInputCompanyName = (e) => {
    setInputCompanyName(e.target.value)

    if (e.target.value === '') {
      setSearchedCompanyName(companyName)
    } else {
      setSearchedCompanyName(
        [...companyName].filter((v) =>
          v.kol_name.toLowerCase().includes(e.target.value.toLowerCase())
        )
      )
    }
  }

  const searchCompanyName = (e) => {
    e.preventDefault()
    setSearchedCompanyName(
      searchedCompanyName.filter((v) => v.kol_name.includes(inputCompanyName))
    )
    // console.log(inputCompanyName)
  }

  const [show, setShow] = useState(false)

  const offcanvasClose = () => setShow(false)
  const offcanvasShow = () => setShow(true)

  return (
    <>
      <Container>
        {/* <h3 className="text-center fw-bold m-3">綜合分析</h3> */}
        <Navbar expand="md" className="mb-lg-3 mb-0 mt-4">
          <Container fluid>
            <Navbar.Toggle
              aria-controls="offcanvasNavbar-expand-md"
              className="p-3 fw-bold fs-6 bg-white"
              onClick={offcanvasShow}
            >
              <i className="fa-solid fa-list-ul"></i> <span>選擇旗下品牌</span>
            </Navbar.Toggle>

            <Navbar.Offcanvas
              show={show}
              onHide={offcanvasClose}
              id="offcanvasNavbar-expand-md"
              aria-labelledby="offcanvasNavbarLabel-expand-md"
              placement="start"
              className="w-75"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel-expand-md">
                  全部旗下品牌
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body className="flex-column">
                <Form
                  className="d-flex flex-column flex-xl-row flex-grow-1"
                  onSubmit={searchCompanyName}
                >
                  <Form.Control
                    type="search"
                    placeholder="請輸入關鍵字"
                    aria-label="Search"
                    value={inputCompanyName}
                    onChange={(e) => {
                      handleInputCompanyName(e)
                    }}
                    className="me-2"
                  />
                  <Button
                    variant="secondary mt-3 mt-xl-0 col-12 col-xl-3"
                    type="submit"
                  >
                    <i className="fa-solid fa-search "></i>
                    <span> 查詢</span>
                  </Button>
                </Form>
                <ListGroup
                  variant="flush"
                  className="mt-3"
                  // defaultActiveKey="#listAll"
                >
                  <ListGroup.Item
                    href="#listAll"
                    action
                    className={currentCompanyId ? '' : 'active'}
                    onClick={() => {
                      setCurrentCompanyId(null)
                      offcanvasClose()
                      setSearchedCompanyName(companyName)
                    }}
                  >
                    全部品牌
                  </ListGroup.Item>
                  {/* TODO: 按按鈕撈特定公司資料 */}
                  {searchedCompanyName.map((v, i) => {
                    return (
                      <ListGroup.Item
                        action
                        activeclassname="active"
                        key={uuidv4()}
                        className={
                          currentCompanyId === v.kol_id ? 'active' : ''
                        }
                        onClick={() => {
                          setCurrentCompanyId(v.kol_id)
                          offcanvasClose()
                        }}
                        href={`#${v.kol_id}`}
                      >
                        {v.kol_name}
                      </ListGroup.Item>
                    )
                  })}
                </ListGroup>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </Container>
    </>
  )
}

export default GroupSideBar
